const e=1.5,o=2e3;export{e as countdownTime,o as delay};
//# sourceMappingURL=config.js.map
